import React, { useContext, useState } from 'react';
import {
  StateSelectField,
  InputField
} from '@trp-beacon-ui-kit/react-controls';
import { ToolTip } from '@trp-beacon-ui-kit/react-communication';
import { handleInputFormat } from '../../flows/shared/utils';
import { FlowContext } from '../../core/flow-engine';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import styles from './styles.css';
import questionMark from '../../images/icon_question_mark.svg';
import Heading from '../../components/Typography/Heading/Heading';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

export const BranchAddressTitleWithTooltip = () => {
  const description = (
    <div style={{ zIndex: 10 }}>
      Where can I find this? <br />
      You can find your branch&apos;s address on your statement.
    </div>
  );
  return (
    <div className="tooltip-wrapper">
      Branch Address{' '}
      <ToolTip
        id="0"
        description={description}
        callerText={
          <img
            alt="question mark"
            src={questionMark}
            width="16px"
            height="16px"
          />
        }
      />
      <style jsx>{styles}</style>
    </div>
  );
};

const CustodianAddressDetailsScreen = () => {
  const { appState, next, back, formProps } = useContext(FlowContext);
  const {
    store: {
      app: {
        custodian: { custodianName }
      }
    }
  } = appState;
  const [phoneValue, setPhoneValue] = useState('');

  return (
    <>
      <div className="custodian-branch-details">
        <div className="title-wrapper">
          <Heading text={`Enter the details for ${custodianName}`} />
        </div>

        <div className="address-fields">
          <div className="address-line1">
            <InputField
              title={<BranchAddressTitleWithTooltip />}
              {...formProps.custodianDetailsStreet1}
              maxLength="35"
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianAddressStreetOne'
              )}
            />
          </div>
          <div className="address-line2">
            <InputField
              title="Address Line 2 (optional)"
              {...formProps.custodianDetailsStreet2}
              maxLength="35"
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianAddressStreetTwo'
              )}
            />
          </div>
        </div>
        <div className="address-fields">
          <div className="city-input">
            <InputField
              title="City"
              {...formProps.custodianDetailsCity}
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianAddressCity'
              )}
            />
          </div>
          <div className="zipcode-input">
            <InputField
              title="Zip Code"
              {...formProps.custodianDetailsZip}
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianAddressZip'
              )}
            />
          </div>
          <div className="state-input">
            <StateSelectField
              title="State"
              {...formProps.custodianDetailsState}
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianAddressState'
              )}
            />
          </div>
        </div>
        <div className="contact-fields">
          <div className="phone-input">
            <InputField
              title="Phone Number"
              placeholder="(000) 000-0000"
              onChange={evt => handleInputFormat(evt, 'PHONE', setPhoneValue)}
              value={phoneValue}
              maxLength="14"
              data-name={generateGeneralTestID(
                'CustodianInstitution',
                'CustodianPhoneNumber'
              )}
              {...formProps.custodianDetailsPhone}
            />
          </div>
        </div>
      </div>

      <div className="button-container">
        <MFBeaconButton
          variant="primary"
          size="normal"
          id="custodianDetailsContinue"
          data-name={generateGeneralTestID(
            'CustodianInstitution',
            'ContinueButton'
          )}
          className="continue-btn"
          onClick={next()}
          label="Continue"
        />
        <MFBeaconButton
          variant="secondary"
          size="normal"
          id="custodianDetailsBack"
          data-name={generateGeneralTestID(
            'CustodianInstitution',
            'BackButton'
          )}
          className="beacon-button-margin-override"
          onClick={back()}
          label="Back to Summary"
        />
      </div>
      <PhoneNumber />

      <style jsx>{styles}</style>
    </>
  );
};

export default CustodianAddressDetailsScreen;
